export const ROUTER_REDIRECT = 'ROUTER_REDIRECT';

export function redirect(to) {
    return {
        type: ROUTER_REDIRECT,
        to: to,
    }
}



// WEBPACK FOOTER //
// ./src/actions/router.js